import React from 'react'

const ArrowDown = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="18" height="18" x="0" y="0" viewBox="0 0 123.959 123.958"><g><path d="M117.979 28.017h-112c-5.3 0-8 6.4-4.2 10.2l56 56c2.3 2.3 6.1 2.3 8.401 0l56-56c3.799-3.8 1.099-10.2-4.201-10.2z" fill="#000000"></path></g></svg>
  )
}

export default ArrowDown